import React from 'react';
import Route from './routes';
import { useSwitchChain } from 'wagmi';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { config } from '@repo/common-types';
import posthog from 'posthog-js';
import { usePrivy } from '@privy-io/react-auth';
import ConfirmationModalContainer from './components/ConfirmationModal/ConfirmationModalContainer';

function App() {
  const { chains: _chains, switchChain } = useSwitchChain();
  const { user: privyUser, ready } = usePrivy();

  React.useEffect(() => {
    switchChain({ chainId: config.blockchain.chainId });
  }, []);

  React.useEffect(() => {
    if (privyUser?.email?.address) {
      posthog.identify(privyUser.id, {
        email: privyUser.email.address,
      });
    }
  }, [privyUser]);

  if (!ready) {
    return <div>Loading...</div>;
  }

  return (
    <React.Fragment>
      <Route />
      <ToastContainer style={{ zIndex: 9999999 }} />
      <ConfirmationModalContainer />
    </React.Fragment>
  );
}

export default App;
